import { HttpSuccessDto } from '@common/dto/http';
import { UserMaintenanceClasses } from '@common/dto/user-maintenance/classes';
import client from '@common/utils/rest';

export const getFolderSecuritySettingsClasses = () => {
  return client({
    path: "api/userMaintenance/classes",
    method: "GET",
  }).then((response: HttpSuccessDto<UserMaintenanceClasses>) => {
    return response.entity;
  });
};
